var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('MainSidebar',{attrs:{"menu-items":_vm.menuItems}}),_c('el-container',{attrs:{"direction":"vertical"}},[_c('MainHeader'),_c('el-main',{class:[
        'main',
        {'main--has-fab': !!this.$route.meta.hasFloatingActionButton} ]},[_c('MainBackground'),_c('el-container',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }